import BoxKit from "@/shared/components/kit/box";
import CustomButton from "@/shared/components/kit/button";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
/**
 * ValidationStatus
 *
 * کامپوننت نمایش وضعیت اعتبارسنجی کاربر.
 * - نمایش وضعیت کلی اعتبارسنجی (در انتظار ادمین).
 * - نمایش جزئیات استعلام اعتبار شامل تاریخ، توضیحات و دکمه مشاهده جزئیات.
 * - شامل دکمه بازگشت به صفحه اصلی.
 *
 * @component
 * @returns JSX.Element
 */

const ValidationStatus = () => {
  return (
    <StackKit direction="column" alignItems={"start"} sx={{ width: "100%", height: "100%" }} justifyContent={"space-around"}>
      <TypoGraphyKit variant="h6">
        وضعیت اعتبار سنجی: در انتظار ادمین
      </TypoGraphyKit>
      <TypoGraphyKit variant="body1">جزئیات اعتبار سنجی: </TypoGraphyKit>
      <StackKit direction="row" gap={3} justifyContent={"center"} sx={{ width: "100%" }} spacing={0}>
        <BoxKit sx={{display: "flex",width: "20%",height: "80px",justifyContent: "center",flexDirection: "column",alignItems: "center",gap: 2,}}>
          <TypoGraphyKit sx={{ color: "#767676" }} variant="body1">
            test
          </TypoGraphyKit>
          <StackKit justifyContent={"center"} sx={{background:"linear-gradient(90deg, #313131 -24.77%, #252525 113.55%)",borderRadius: "8px",width: "100%",height: "40px",}}>
            <TypoGraphyKit variant="body1"> 1403/10/30</TypoGraphyKit>
          </StackKit>
        </BoxKit>
        <BoxKit sx={{display: "flex",width: "30%",height: "80px",flexDirection: "column",alignItems: "center",justifyContent: "center",gap: 2,}}>
          <TypoGraphyKit sx={{ color: "#767676" }} variant="body1">
            test
          </TypoGraphyKit>
          <StackKit justifyContent={"center"} sx={{background:"linear-gradient(90deg, #313131 -24.77%, #252525 113.55%)",borderRadius: "8px",width: "100%",height: "40px",}}>
            <TypoGraphyKit variant="body1">
              در انتظار تایید استعلامات اعتبار سنجی
            </TypoGraphyKit>
          </StackKit>
        </BoxKit>
        <BoxKit sx={{display: "flex",width: "20%",height: "80px",flexDirection: "column",alignItems: "center",justifyContent: "center",gap: 2,}}>
          <TypoGraphyKit sx={{ color: "#767676", height: "20px" }} variant="body1"></TypoGraphyKit>
          <CustomButton sx={{ width: "100%" }}>مشاهده جزئیات</CustomButton>
        </BoxKit>
      </StackKit>
      <StackKit direction={"row"} justifyContent={"end"} sx={{ width: "100%" }}>
        <CustomButton>بازگشت به صفحه اصلی</CustomButton>
      </StackKit>
    </StackKit>
  );
};

export default ValidationStatus;
